(() => {
  const fetchNostoWishlists = () => {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }
    window.SwymCallbacks.push(() => {
      window._swat.fetchLists({
        callbackFn: response => {
          if (response.length) {
            let listIds = []
            let lists = []
            let data = []
            response.forEach((item, i) => {
              if (listIds.includes(item.lid)) return
              lists.push(item)
              listIds.push(item.lid)
            })
            lists.forEach((item, i) => {
              const productsArray = []
              window._swat.fetchListCtx(
                {
                  lid: item.lid
                },
                products => {
                  if (products.length) {
                    const uniqueProducts = products.filter((e, i) => products.findIndex(a => a.epi === e.epi) === i)

                    uniqueProducts.forEach(product => {
                      window._swat.getProductDetails(
                        product,
                        resp => {
                          resp.swym = product

                          resp.variants.forEach(variant => {
                            if (variant.id === resp.swym.epi) {
                              resp.selected_variant = variant
                            }
                          })
                          productsArray.push(resp)
                        },
                        err => {
                          console.log(err)
                        }
                      )
                    })
                  }
                },
                err => {
                  console.log(err)
                }
              )
              data.push(productsArray)
            })

            const wishProducts = lists.map(list => list.listcontents).flat()

            if (document.querySelector('[data-quick-shop] [data-wishlist-button]')) {
              const quickshops = document.querySelectorAll('[data-quick-shop]')
              quickshops.forEach((quickshop) => {
                const wishExists = quickshop.querySelectorAll('.wish-exists')
                const quickshopProducts = quickshop.querySelectorAll('[data-wishlist-button]')
                wishExists.forEach((wishExist) => {
                  wishExist.classList.remove('wish-exists')
                })
                quickshopProducts.forEach((quickshopProduct) => {
                  wishProducts.forEach((wishProduct) => {
                    const pId = parseInt(quickshopProduct.getAttribute('data-wishlist-button'))
                    const container = quickshopProduct.closest('[data-quick-shop-item]')
                    if (wishProduct.empi === pId) {
                      container.classList.add('wish-exists')
                    }
                  })
                })
              })
            }
          }
        },
        errorFn: err => {
          console.log(err)
        }
      })
    })
  }

  fetchNostoWishlists()
})();
